// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__16JpE","selects":"Documents_selects__tvXp_"};